<div
  class="linked-partners-field-container"
  [formGroup]="form"
>
  <div
    *ngIf="linkedPartners?.controls?.length"
    class="linked-partners-container"
    [formArrayName]="controlName"
  >
    <ng-container
      *ngFor="let partner of linkedPartners.controls; let i = index"
      [formGroup]="partner"
    >
      <mat-form-field
        class="field subscripts"
        appearance="outline"
        color="primary"
      >
        <input
          matInput
          formControlName="partnerId"
          autocomplete="off"
          [errorStateMatcher]="matcher"
          maxlength="100"
          placeholder="Partner ID"
        />
        <mat-error *ngIf="partner.controls['partnerId'].hasError('required')">ID required</mat-error>
        <mat-error *ngIf="partner.controls['partnerId'].hasError('partnerId')">{{
          partner.controls["partnerId"].getError("partnerId")
        }}</mat-error>
      </mat-form-field>
      <mat-form-field
        class="field subscripts"
        appearance="outline"
        color="primary"
      >
        <input
          matInput
          formControlName="partnerName"
          autocomplete="off"
          [errorStateMatcher]="matcher"
          placeholder="Partner Name"
          readonly
        />
      </mat-form-field>
      <div class="controls">
        <button
          mat-flat-button
          class="button-delete"
          color="warn"
          (click)="onDeleteLinkedParter(i)"
        >
          Delete
        </button>
        <ng-container *ngTemplateOutlet="controlsTemplateRef; context: { $implicit: partner.controls['partnerId'].value }"></ng-container>
      </div>
    </ng-container>
  </div>
  <button
    class="button-add"
    mat-flat-button
    color="accent"
    (click)="onAddLinkedPartner()"
  >
    Add
  </button>
</div>
